import { render, staticRenderFns } from "./UserInfoCard.vue?vue&type=template&id=3d4ca9ee&scoped=true"
import script from "./UserInfoCard.vue?vue&type=script&lang=ts"
export * from "./UserInfoCard.vue?vue&type=script&lang=ts"
import style0 from "./UserInfoCard.vue?vue&type=style&index=0&id=3d4ca9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4ca9ee",
  null
  
)

export default component.exports